module.exports = __webpack_public_path__ + "static/media/relieved-face-svgrepo-com.85b07bbd.svg";